import http from '@/http';

export default class ProvaService {

    gerarResultado(idProcesso) {
      return http.get(`prova/gabarito/listar/${idProcesso}`).then(res => res.data);
    }

    importarGabarito(procesoSeletivoId, processoAreaId, arquivo) {
      const gabaritoDto = new FormData();
      gabaritoDto.append('idProcessoSeletivo', procesoSeletivoId);
      gabaritoDto.append('idProcessoSeletivoArea', processoAreaId);
      gabaritoDto.append('arquivoGabarito', arquivo);

      console.log(gabaritoDto);

      return http.post(`prova/gabarito/upload`, gabaritoDto).then(res => res.data);
    }

    importarRespostas(procesoSeletivoId, arquivo) {
      const gabaritoDto = new FormData();
      gabaritoDto.append('idProcessoSeletivo', procesoSeletivoId);
      gabaritoDto.append('arquivoRespostas', arquivo);

      return http.post(`prova/respostas/upload`, gabaritoDto).then(res => res.data);
    }

    importarRespostasDiscursivas(procesoSeletivoId, arquivo) {
      const gabaritoDto = new FormData();
      gabaritoDto.append('idProcessoSeletivo', procesoSeletivoId);
      gabaritoDto.append('arquivoRespostas', arquivo);

      return http.post(`prova/respostas/discursiva/upload`, gabaritoDto).then(res => res.data);
    }

    getResumoResposta(idProcesso) {
      return http.get(`prova/respostas/resumo/${idProcesso}`).then(res => res.data);
    }

    getResumoRespostaDiscursivas(idProcesso) {
      return http.get(`prova/respostas/resumo/discursivas/${idProcesso}`).then(res => res.data);
    }

}
